import React, { useState, useEffect } from "react";
import bioImg from "../images/by-my-side-homepage_seuil22.jpg";
import { Link } from "react-router-dom";

export default function Exhibitions() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timeout);
  }, []);
  return (
    <div className={`exhibitions-fade${visible ? " fade-in" : ""}`}>
      <Link to="/" className="bio">
        <img className="bioImg" src={bioImg} alt="bioImg" />
      </Link>
      <div className="exhibitionText">
        <p>
          Solo and Duo exhibitions<br></br>
          <p>
            <span className="exhibitionStar">✧</span> Odd Balade,{" "}
            <span className="infoExhibition">
              Trypheme and friends, Bagnoler, Paris France, 2024.
            </span>
          </p>
          <p>
            <span className="exhibitionStar">✧</span> Blue Shift,{" "}
            <span className="infoExhibition">
              Studio9 Totnes, England 2024.
            </span>
          </p>
          <br></br>
          <br></br>
        </p>
        <p>
          Group exhibitions<br></br>
          <p>
            <span className="exhibitionStar">✧</span> Florn,{" "}
            <span className="infoExhibition">
              Floreal Bellville, Paris France, 2025.
            </span>
          </p>
          <p>
            <span className="exhibitionStar">✧</span> Forever Just For One
            Moment,{" "}
            <span className="infoExhibition">
              Kaamer Gallery., Koenji, Tokyo Japan, 2023.
            </span>
          </p>
          <p>
            <span className="exhibitionStar">✧</span> Soft Touch,{" "}
            <span className="infoExhibition">
              Avalon Cafe Bermondsey, London England 2021.
            </span>
          </p>
          <p>
            <span className="exhibitionStar">✧</span> Pelukeria,{" "}
            <span className="infoExhibition">
              Voiture 14, Marseille France, 2021
            </span>
          </p>
        </p>
      </div>
      <div className="exhibitions-background"></div>
    </div>
  );
}
